import React from 'react';
import {
  RangePickerProps as OriginalProps,
  RangePicker as RCPicker,
  // PickerPanelProps,
} from 'rc-picker';
import enUS from 'rc-picker/lib/locale/en_US';
import skSK from 'rc-picker/lib/locale/sk_SK';

import generateFns from 'rc-picker/lib/generate/dateFns';
import generateMoment from 'rc-picker/lib/generate/moment';
import { SharedTimeProps } from 'rc-picker/lib/panels/TimePanel';

import { ReactComponent as SuperNextIcon } from '../../../../assets/svg/pickers/picker_super_next.svg';
import { ReactComponent as NextIcon } from '../../../../assets/svg/pickers/picker_next.svg';
import { ReactComponent as SuperPrevIcon } from '../../../../assets/svg/pickers/picker_super_prev.svg';
import { ReactComponent as PrevIcon } from '../../../../assets/svg/pickers/picker_prev.svg';
import { RangePickerSC } from './range-picker.styled';
import { RangePickerSharedProps } from 'rc-picker/lib/RangePicker';
import { useSelector } from 'react-redux';
import TStore from '../../../../types/store';

type TPickerType = <T extends any>(
  props: RangePickerProps<T> & React.RefAttributes<RCPicker<T>>,
) => JSX.Element;

type ToOmit =
  | 'locale'
  | 'generateConfig'
  | 'separator'
  | 'nextIcon'
  | 'superNextIcon'
  | 'prevIcon'
  | 'superPrevIcon';

type CombinedProps<T> = Omit<
  RangePickerSharedProps<T> &
    SharedTimeProps<T> &
    // Omit<PickerPanelProps<T>, ToOmit> &
    OriginalProps<T>,
  ToOmit
>;

export type PickerKinds = 'inline' | 'bubble' | 'history';

type RangePickerProps<T> = CombinedProps<T> & {
  locale?: 'sk' | 'en';
  generateConfig: 'moment' | 'dateFns';
  kind?: PickerKinds;
};

const RangePicker = <T extends any>(
  { locale, generateConfig = 'moment', ...rest }: RangePickerProps<T>,
  ref?: React.Ref<RCPicker<T>>,
) => {
  const lang = useSelector((state: TStore) => locale || state.app.currentLang);
  return (
    // @ts-ignore
    <RangePickerSC
      {...rest}
      ref={ref as any}
      locale={lang === 'sk' ? skSK : enUS}
      generateConfig={(generateConfig === 'moment' ? generateMoment : generateFns) as any}
      separator="-"
      nextIcon={<NextIcon />}
      superNextIcon={<SuperNextIcon />}
      prevIcon={<PrevIcon />}
      superPrevIcon={<SuperPrevIcon />}
    />
  );
};

// @ts-ignore
export default React.forwardRef(RangePicker) as TPickerType;
